import { render, staticRenderFns } from "./shangYeZhuangKuang.vue?vue&type=template&id=6654dce2&scoped=true&"
import script from "./shangYeZhuangKuang.vue?vue&type=script&lang=js&"
export * from "./shangYeZhuangKuang.vue?vue&type=script&lang=js&"
import style0 from "./shangYeZhuangKuang.vue?vue&type=style&index=0&id=6654dce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654dce2",
  null
  
)

export default component.exports